import React from 'react'
import { Header } from './partials/Header'
import { Hero } from './partials/Hero'
import { Slogan } from './partials/Slogan'
import { Concept } from './partials/Concept'
import { Timeline } from './partials/Timeline'
import { Company } from './partials/Company'
import { Contact } from './partials/Contact'
import { Footer } from './partials/Footer'

export const HomePage = () => (
  <>
    <Header />
    <Hero />
    <Slogan />
    <Concept />
    <Timeline />
    <Company />
    <Contact />
    <Footer />
  </>
)
